import { RiHomeHeartFill } from "react-icons/ri";
import { BiMessageAltDetail } from "react-icons/bi";
import { PiCardholderBold } from "react-icons/pi";

export const version = '' //версия приложения

export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL
export const BACKEND_DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN

export const itemsOnPage = 20

export const itemsCount = [10,15,20,25,30]

export const mainMenu = [
    {
        name: 'Карточка',
        link: '/',
        icon: <RiHomeHeartFill/>,
        innerLinks: [
            {
                name: 'text',
                link: 'text'
            }
        ]
    },{
        name: 'История чатов',
        link: '/messages',
        icon: <PiCardholderBold/>,
        innerLinks: [
            {
                name: 'text',
                link: 'text'
            }
        ]
    },{
        name: 'Новый чат',
        link: '/chat/new',
        icon: <BiMessageAltDetail/>,
        innerLinks: [
            {
                name: 'text',
                link: 'text'
            }
        ]
    }
]

export const model = 'gpt-4o-mini';

export const token = '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';


export const patientCard = {
    "Личная информация": {
      "Фамилия": "Лебедев",
      "Имя": "Кирилл",
      "Возраст": "27",
      "Пол": "Мужской",
      "Адрес": "г. Санкт-Петербург",
      "Родственные связи": "Жена: Анна, Мать: Ольга"
    },
    "Медицинская история": {
      "Перенесенные заболевания или травмы": "Осколочное ранение правого плеча в 2022 году, контузия",
      "Лечение": "Хирургическое лечение ранения, реабилитация после контузии",
      "Принимаемые лекарства": "Анальгетики для снятия боли, снотворное по назначению врача"
    },
    "Психологическая история": {
      "Предыдущие психиатрические диагнозы и лечения": "Нет официальных диагнозов до участия в СВО",
      "Проблемы с психическим здоровьем": "Периодические вспышки агрессии, тревожность",
      "Личный опыт жизни": "Участие в специальной военной операции (СВО), командир отделения",
      "Социальные отношения": "Близкие отношения с женой, ограниченное общение с друзьями из-за травматического опыта"
    },
    "Травматические события": {
      "Дата и место события": "12.03.2022, территория проведения СВО",
      "Обстоятельства и последствия события": "Обстрел позиций противником, потеря двух сослуживцев, ранение и контузия",
      "Ограничения в повседневной деятельности": "Трудности с выполнением физических нагрузок, избегание новостей о войне",
      "Тревога или страх-ожидание": "Частые мысли о возможном повторении боевых действий, боязнь громких звуков"
    },
    "Симптомы ПТСР": {
      "Чрезмерное воспоминание событий": "Да, особенно при звуках салюта или взрывов",
      "Бессонница": "Да, часто просыпаюсь среди ночи",
      "Кошмары": "Да, практически каждую ночь",
      "Чувство вины и отчуждения": "Чувство вины за то, что выжил, в то время как сослуживцы погибли",
      "Избегание ситуаций или мест, связанных с травмой": "Да, избегаю военных фильмов, новостей о войне",
      "Вспышки ярости или агрессии": "Да, особенно при стрессовых ситуациях",
      "Чувство опасности": "Постоянное ощущение угрозы, даже в безопасных местах"
    },
    "Социальная история": {
      "Занятость": "Не работаю, прохожу реабилитацию",
      "Семейные отношения и друзья": "Жена поддерживает, но чувствую себя отстраненным, общение с друзьями минимальное",
      "Уровень социальной поддержки": "Средний, семья старается помочь, но сложно говорить о пережитом"
    },
    "Прошлые методы лечения ПТСР": {
      "Оказание помощи в прошлом": "Краткосрочная психологическая помощь на базе военного госпиталя",
      "Эффективность методов лечения": "Низкая эффективность, необходимы дополнительные методы терапии"
    },
    "Социальные факторы": {
      "Наличие дискриминации": "Нет",
      "Уровень дохода или безработицы": "Временно не работаю, выплачивается военное пособие",
      "Безопасность жизни": "Жизнь в безопасном районе, но чувство тревоги сохраняется"
    }
  };


export const chatList = [
      {
          date: "2025-03-03",
          title: "Адаптация после службы: первые шаги",
          text: "Обсудили важность восстановления режима, физической активности и поддержки семьи после выхода в запас.",
          theme: "Адаптация",
          id: 1,
          tags: ["адаптация", "военнослужащие", "психология"],
          messages: [
            {
                "role": "user",
                "content": "Привет, меня зовут Кирилл"
            },
            {
                "role": "assistant",
                "content": "Привет, Кирилл! 😊 Рад приветствовать тебя здесь. Как ты себя чувствуешь сегодня? Как твои дела?"
            },
            {
                "role": "user",
                "content": "Я… не знаю, с чего начать. Просто после всего, что было там… в голове постоянный шум. Кошмары, вспышки агрессии, страх пространства. Иногда кажется, что я снова там."
            },
            {
                "role": "assistant",
                "content": "Мне очень жаль слышать, что ты переживаешь такие трудные моменты. 💔 Это действительно тяжело, когда поднимаются воспоминания и эмоции, которые сложно контролировать. \n\nТы не одинок в этом, множество людей испытывают подобные чувства после травмирующих событий. Это может быть тяжело, но важно знать, что помощь доступна, и ты заслуживаешь поддержки. \n\nМожет, подумаем о том, что помогает тебе немного успокоиться в такие моменты? Или, может быть, есть что-то конкретное, что ты бы хотел обсудить? Я тут, чтобы тебя поддержать.❤️"
            },
            {
                "role": "user",
                "content": "Первые месяцы казалось, что все нормально. Я даже пытался работать, общаться с семьей. Но потом стало хуже. Особенно когда громкие звуки или толпы людей."
            },
            {
                "role": "assistant",
                "content": "Понимаю, Кирилл. 🌧️ Иногда после напряженных событий действительно может показаться, что всё идет хорошо, но в какой-то момент нажимается \"кнопка\", и начинает проявляться все то, что мы не осознавали. Это нормально – чувствовать себя некомфортно в толпе или при громких звуках, особенно после того, что ты пережил.\n\nЭти реакции могут быть сильными и неожиданными. Ты пробовал заботиться о себе в такие моменты? Так называемые «стратегии самопомощи» могут быть полезными, например, дыхательные упражнения или поиск спокойного места. \n\nКак ты обычно справляешься в такие моменты? Есть что-то, что тебе помогает немного расслабиться? 🌿"
            }
        ]
      },
      {
          date: "2025-03-03",
          title: "ПТСР и способы его преодоления",
          text: "Разбирали, как проявляется посттравматический синдром, какие техники помогают снизить тревогу и стресс.",
          theme: "Психология",
          id: 2,
          tags: ["ПТСР", "психология", "поддержка"],
          messages: [
            {
                "role": "user",
                "content": "Привет, меня зовут Кирилл"
            },
            {
                "role": "assistant",
                "content": "Привет, Кирилл! 😊 Рад приветствовать тебя здесь. Как ты себя чувствуешь сегодня? Как твои дела?"
            },
            {
                "role": "user",
                "content": "Я… не знаю, с чего начать. Просто после всего, что было там… в голове постоянный шум. Кошмары, вспышки агрессии, страх пространства. Иногда кажется, что я снова там."
            },
            {
                "role": "assistant",
                "content": "Мне очень жаль слышать, что ты переживаешь такие трудные моменты. 💔 Это действительно тяжело, когда поднимаются воспоминания и эмоции, которые сложно контролировать. \n\nТы не одинок в этом, множество людей испытывают подобные чувства после травмирующих событий. Это может быть тяжело, но важно знать, что помощь доступна, и ты заслуживаешь поддержки. \n\nМожет, подумаем о том, что помогает тебе немного успокоиться в такие моменты? Или, может быть, есть что-то конкретное, что ты бы хотел обсудить? Я тут, чтобы тебя поддержать.❤️"
            },
            {
                "role": "user",
                "content": "Первые месяцы казалось, что все нормально. Я даже пытался работать, общаться с семьей. Но потом стало хуже. Особенно когда громкие звуки или толпы людей."
            },
            {
                "role": "assistant",
                "content": "Понимаю, Кирилл. 🌧️ Иногда после напряженных событий действительно может показаться, что всё идет хорошо, но в какой-то момент нажимается \"кнопка\", и начинает проявляться все то, что мы не осознавали. Это нормально – чувствовать себя некомфортно в толпе или при громких звуках, особенно после того, что ты пережил.\n\nЭти реакции могут быть сильными и неожиданными. Ты пробовал заботиться о себе в такие моменты? Так называемые «стратегии самопомощи» могут быть полезными, например, дыхательные упражнения или поиск спокойного места. \n\nКак ты обычно справляешься в такие моменты? Есть что-то, что тебе помогает немного расслабиться? 🌿"
            }
        ]
      },
      {
          date: "2025-03-03",
          title: "Как найти работу после армии?",
          text: "Обсудили, как адаптировать военный опыт под гражданские профессии и где искать поддержку в трудоустройстве.",
          theme: "Карьера",
          id: 3,
          tags: ["работа", "профориентация", "адаптация"],
          messages: [
            {
                "role": "user",
                "content": "Привет, меня зовут Кирилл"
            },
            {
                "role": "assistant",
                "content": "Привет, Кирилл! 😊 Рад приветствовать тебя здесь. Как ты себя чувствуешь сегодня? Как твои дела?"
            },
            {
                "role": "user",
                "content": "Я… не знаю, с чего начать. Просто после всего, что было там… в голове постоянный шум. Кошмары, вспышки агрессии, страх пространства. Иногда кажется, что я снова там."
            },
            {
                "role": "assistant",
                "content": "Мне очень жаль слышать, что ты переживаешь такие трудные моменты. 💔 Это действительно тяжело, когда поднимаются воспоминания и эмоции, которые сложно контролировать. \n\nТы не одинок в этом, множество людей испытывают подобные чувства после травмирующих событий. Это может быть тяжело, но важно знать, что помощь доступна, и ты заслуживаешь поддержки. \n\nМожет, подумаем о том, что помогает тебе немного успокоиться в такие моменты? Или, может быть, есть что-то конкретное, что ты бы хотел обсудить? Я тут, чтобы тебя поддержать.❤️"
            },
            {
                "role": "user",
                "content": "Первые месяцы казалось, что все нормально. Я даже пытался работать, общаться с семьей. Но потом стало хуже. Особенно когда громкие звуки или толпы людей."
            },
            {
                "role": "assistant",
                "content": "Понимаю, Кирилл. 🌧️ Иногда после напряженных событий действительно может показаться, что всё идет хорошо, но в какой-то момент нажимается \"кнопка\", и начинает проявляться все то, что мы не осознавали. Это нормально – чувствовать себя некомфортно в толпе или при громких звуках, особенно после того, что ты пережил.\n\nЭти реакции могут быть сильными и неожиданными. Ты пробовал заботиться о себе в такие моменты? Так называемые «стратегии самопомощи» могут быть полезными, например, дыхательные упражнения или поиск спокойного места. \n\nКак ты обычно справляешься в такие моменты? Есть что-то, что тебе помогает немного расслабиться? 🌿"
            }
        ]
      },
      {
          date: "2025-03-03",
          title: "Семья после службы: как сохранить отношения?",
          text: "Говорили о трудностях в общении с близкими после возвращения и способах налаживания контакта.",
          theme: "Семья",
          id: 4,
          tags: ["семья", "адаптация", "психология"],
          messages: [
            {
                "role": "user",
                "content": "Привет, меня зовут Кирилл"
            },
            {
                "role": "assistant",
                "content": "Привет, Кирилл! 😊 Рад приветствовать тебя здесь. Как ты себя чувствуешь сегодня? Как твои дела?"
            },
            {
                "role": "user",
                "content": "Я… не знаю, с чего начать. Просто после всего, что было там… в голове постоянный шум. Кошмары, вспышки агрессии, страх пространства. Иногда кажется, что я снова там."
            },
            {
                "role": "assistant",
                "content": "Мне очень жаль слышать, что ты переживаешь такие трудные моменты. 💔 Это действительно тяжело, когда поднимаются воспоминания и эмоции, которые сложно контролировать. \n\nТы не одинок в этом, множество людей испытывают подобные чувства после травмирующих событий. Это может быть тяжело, но важно знать, что помощь доступна, и ты заслуживаешь поддержки. \n\nМожет, подумаем о том, что помогает тебе немного успокоиться в такие моменты? Или, может быть, есть что-то конкретное, что ты бы хотел обсудить? Я тут, чтобы тебя поддержать.❤️"
            },
            {
                "role": "user",
                "content": "Первые месяцы казалось, что все нормально. Я даже пытался работать, общаться с семьей. Но потом стало хуже. Особенно когда громкие звуки или толпы людей."
            },
            {
                "role": "assistant",
                "content": "Понимаю, Кирилл. 🌧️ Иногда после напряженных событий действительно может показаться, что всё идет хорошо, но в какой-то момент нажимается \"кнопка\", и начинает проявляться все то, что мы не осознавали. Это нормально – чувствовать себя некомфортно в толпе или при громких звуках, особенно после того, что ты пережил.\n\nЭти реакции могут быть сильными и неожиданными. Ты пробовал заботиться о себе в такие моменты? Так называемые «стратегии самопомощи» могут быть полезными, например, дыхательные упражнения или поиск спокойного места. \n\nКак ты обычно справляешься в такие моменты? Есть что-то, что тебе помогает немного расслабиться? 🌿"
            }
        ]
      }
  ]